import { render, staticRenderFns } from "./chatdetail.vue?vue&type=template&id=a4b0e3da&scoped=true&"
import script from "./chatdetail.vue?vue&type=script&lang=js&"
export * from "./chatdetail.vue?vue&type=script&lang=js&"
import style0 from "./chatdetail.vue?vue&type=style&index=0&id=a4b0e3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b0e3da",
  null
  
)

export default component.exports